var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns",attrs:{"id":"class"}},[_vm._v("\n        Edit this shit!!!\n\t")])}
var staticRenderFns = []

export { render, staticRenderFns }